import React from 'react';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  TooltipProps,
} from 'recharts';

import { Container, Description } from './styles';

import { GraficoProps } from './interface';

import RelatorioVendaUfEstado from '~/@types/RelatorioVendaUfEstado';

import {
  NameType,
  ValueType,
} from 'recharts/types/component/DefaultTooltipContent';

interface CustomTooltipProps extends TooltipProps<ValueType, NameType> {
  // Add any additional custom props you might need
}

const exibicaoTotalPedidos = (pTotalPedidos: number) => {
  if (!pTotalPedidos) return 'Nenhum pedido';
  if (pTotalPedidos === 1) {
    return 'Um pedido';
  }
  return `${pTotalPedidos} pedidos`;
};

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  active,
  payload,
  label,
}) => {
  if (active && payload && Array.isArray(payload) && payload.length) {
    const [cPayload] = payload;

    if (cPayload) {
      const { payload: _payload } = cPayload;
      if (_payload) {
        const item: RelatorioVendaUfEstado = {
          ..._payload,
        };

        return (
          <Description>
            <main>
              <div>
                <h1>{item.nome}</h1>
                <h2>{exibicaoTotalPedidos(item.pedidos)}</h2>
                <span>{item.pedidos_porcentagem}% dos pedidos</span>
                <ins />
                <h5>
                  PRODUTOS:
                  <b style={{ color: '#1a4086' }}>
                    {item.produtos.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </b>
                </h5>
                <h5>
                  DESCONTO:
                  <b style={{ color: '#7e431c' }}>
                    {item.frete.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </b>
                </h5>
                <h5>
                  FRETE:
                  <b style={{ color: '#53a4bd' }}>
                    {item.frete.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </b>
                </h5>
                <h5>
                  TOTAL:
                  <b style={{ color: '#179d46' }}>
                    {item.total.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
                  </b>
                </h5>
                <ins />
                <span style={{ color: '#179d46' }}>
                  {item.faturamento_porcentagem}% do faturamento
                </span>
              </div>
            </main>
          </Description>
        );
      }
    }
  }

  return null;
};

const Grafico: React.FC<GraficoProps> = ({ ufs }) => {
  return (
    <Container>
      <ResponsiveContainer>
        <BarChart
          data={ufs}
          margin={{
            top: 0,
            right: 10,
            left: 30,
            bottom: 25,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />

          <YAxis
            tickFormatter={value =>
              `${value.toLocaleString('pt-br', {
                style: 'currency',
                currency: 'BRL',
              })}`
            }
            tick={{ fill: '#999', fontSize: 8 }}
          />

          <XAxis
            dataKey="nome"
            stroke={'#999'}
            fontSize={10}
            angle={0}
            textAnchor="end"
            tickMargin={10}
            dx={25}
          />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: 'rgba(255,255,255, 0.1)' }}
          />

          <YAxis />
          <Tooltip />

          <Bar
            type="monotone"
            dataKey={'total'}
            fill="#555"
            radius={[6, 6, 0, 0]}
          />
        </BarChart>
      </ResponsiveContainer>
    </Container>
  );
};

export default Grafico;
